module.exports = __webpack_public_path__ + "static/media/banner_lane.2f85057b.png";